module.exports = __webpack_public_path__ + "img/prevencion-labores.e43df6e5.jpg";